import React, { useState, useRef, useEffect } from 'react';
import { usePanelModify } from '../../modules/panel';
import { useDispatch, useSelector } from 'react-redux';
import './PanelTypeMenus.css'
import { setLastBasePoint } from '../../redux/utilsSlice';
import PanelDetails from './PanelDetails';
import { setCommandType  } from '../../redux/operationSlice';
import { COMMANDS } from '../../utils/commonProperties';
import { selectAllFloorPlans } from '../../redux/floorPlanSlice';
import { buildDefaultPanelName } from '../../utils/panelNaming';
import { getObjectById } from '../../utils/getObjectById';

export default function MainPanelTypeMenu({
  x,
  y,
  value,
  onClose, 
  mainPanelDetails,
  onActionSelect,
  onDrag,
  scene,
}) {
  const basePoint = mainPanelDetails.basePoint || { x: 0, y: 0, z: 0 };
  const supply = useSelector((state) => state.simpleSupply);
  const floorPlans = useSelector(selectAllFloorPlans);
   const mainPanelHouse = supply.components.find(h => h.kind === "meter_panel")

  const dispatch = useDispatch();

  const [showDetails, setShowDetails] = useState(false);
  const [panelName, setPanelName] = useState(mainPanelDetails.panelName)
  const [selectedAction, setSelectedAction] = useState('MVP');
  const [panel, setPanel] = useState(null)
  const [details, setDetails] = useState(mainPanelHouse.electrical)
  // panoAdi kaldırıldı — yeni panel otomatik isimlendirme alıyor
  // (useElectricalPanelWiring → buildDefaultPanelName, kullanıcı sonradan
  // PanelTypeMenu'den değiştirebilir).
  const [panelDetails, setPanelDetails] = useState({
    aboneTuru: "Mesken",
    purposeOfUse: "Mesken",
    phaseCount: 1,
  });
  const [salt, setSalt] = useState()
  const menuRef = useRef(null);
  const dragData = useRef({ active: false, lastX: 0, lastY: 0 });
  const panelId = mainPanelDetails.id || null;
 
  const changePanelName = (name) => {
    setPanelName(name)
    };

  const drawGrounding = () => {
    dispatch(setCommandType(COMMANDS.DRAW_MPANEL_GROUNDING));
    onClose();

  }
  const changePhaseCount = (count) => {
    // Local state'i güncelle
    if (count === 1) {
      setPanelDetails(prev => ({ ...prev, phaseCount: count }));
    }

  
  };

  useEffect(() => {
     setDetails(mainPanelHouse.electrical)
    //--------------------------------    
  
    const cable = supply.feeders.find(f => f.id === mainPanelHouse.incomingFeeders[0]).cable;

    const AOS = "AOS"//nodes.find(n => n.type.includes('AOS')).electrical.breaker;
    const YKS = "YKS"//nodes.find(n => n.type.includes('YK-TMS')).electrical.breaker;
 
    setSalt({
      cable,
      AOS,
      YKS
    });
  }, [supply]);

  useEffect(() => {
    dispatch(setLastBasePoint(basePoint));
  }, [dispatch, basePoint]);

  useEffect(() => {
    if (!panel) return

    const updatedPanel = updatePanel(panel)
    setDetails(updatedPanel.details)
  }, [panel])

  const { setCount, updatePanel } = usePanelModify(scene);

  const handleActionWithDetails = () => {
    const panel = getObjectById(scene, panelId);
    if (!panel) return;

    const currentOutCount = panel.userData.outs?.length || 0;
    const newCount = currentOutCount + 1;

    // Auto-name: ana panelin (mainPanel) bulunduğu kata göre üret. Kullanıcı
    // wire'ı kablo bacasına çekip yukarı çıkarsa CableShaftTypeMenu Devam Et'te
    // hedef kata göre tekrar hesaplanacak. Final panel oluşurken
    // useElectricalPanelWiring de aynı kuralla son adı atayacak.
    const mainPanelComponent = supply.components.find(c => c.id === panelId);
    const autoName = buildDefaultPanelName({
      position: mainPanelComponent?.position || basePoint,
      floorPlans,
      allComponents: supply.components,
    });
    const commandData = {
      addPosition: 'start',
      command: 'drawPanel',
      phaseCount: panelDetails.phaseCount || 3,
      purposeOfUse: panelDetails.purposeOfUse,
      aboneTuru: panelDetails.aboneTuru,
      name: autoName || undefined, // Boşsa wiring hook fallback yapar
    };
    setCount(panelId, "nodeId", "housingId", newCount, commandData);
    onClose();
  };

  const handleMouseDown = (e) => {
    e.stopPropagation();
    dragData.current = {
      active: true,
      lastX: e.clientX,
      lastY: e.clientY,
    };
    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('mouseup', handleMouseUp);
  };

  const handleMouseMove = (e) => {
    if (!dragData.current.active) return;
    const dx = e.clientX - dragData.current.lastX;
    const dy = e.clientY - dragData.current.lastY;
    dragData.current.lastX = e.clientX;
    dragData.current.lastY = e.clientY;
    onDrag(dx, dy);
  };

  const handleMouseUp = () => {
    dragData.current.active = false;
    window.removeEventListener('mousemove', handleMouseMove);
    window.removeEventListener('mouseup', handleMouseUp);
  };

  useEffect(() => {
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
    };
  }, []);

  return (
    <div
      ref={menuRef} className="panel-type-menu" style={{ left: x, top: y }}
    >
      <div
        onMouseDown={handleMouseDown}
        className="panel-type-menu-header"
      >
        {panelName} /{details.installedPower} W
        <button
          className="close-button"
          onClick={e => { e.stopPropagation(); onClose(); }}
        >
          ×
        </button>
      </div>

      <div className="panel-type-options">

 
        <div className="panel-type-options">
          {selectedAction === 'MVP' && (
            <PanelDetails
              details={panelDetails}
              setDetails={setPanelDetails}
              panelName={panelName}
              setPanelName={setPanelName}
              mainPanelPhaseCount={details.phaseCount} // ana panonun faz sayısı
              onApply={handleActionWithDetails}
            />
          )}

          {/* Diğer action'lar için ileride ayrı bileşenler buraya eklenecek */}
          {selectedAction === 'LIGHT' && (
            <div>Ileride buraya <code>&lt;LightDetails /&gt;</code> eklenecek</div>
          )}
        </div>
      <button
                    onClick={drawGrounding}
                    className="submit-button"
                    style={{ width: '100%' }}
                  >
                    Topraklama Ekle
                  </button>
        <hr></hr>
        <div>
          <button
            onClick={() => setShowDetails(!showDetails)}
            className="my-button"
            style={{
              width: '100%',
              textAlign: 'left',
            }}
          >
            {panelName}   Detay {showDetails ? '▴' : '▾'}
          </button>

          {showDetails && (
            <div className="panel-type-details-box">
              <table className="panel-type-details-table">
                <tbody>
                  <tr  >
                    <td className="label-cell">Pano Adı</td>
                    <td>
                      <input
                        type="text"
                        value={panelName}
                        onChange={(e) => changePanelName(e.target.value)}
                        style={{ width: "100%" }}
                        className='textArea'
                      />

                    </td>
                  </tr>
                  <tr  >
                    <td className="label-cell">Kurulu G.</td>
                    <td>{details.installedPower}W</td>
                  </tr>

                  <tr  >
                    <td className="label-cell">Talep Faktör</td>
                    <td>{details.demandFactor}</td>
                  </tr>

                  <tr  >
                    <td className="label-cell">Talep Güç</td>
                    <td>{details.demandPower}W</td>
                  </tr>

                  <tr  >
                    <td className="label-cell">Faz Sayısı</td>
                    <td>
                      <label>
                        <input
                          type="radio"
                          name="faz"
                          value={1}
                          checked={details.phaseCount === 1}
                          onChange={() => changePhaseCount(1)/* setDetails({ ...details, phaseCount: 1 }) */}
                        />
                        1 Faz
                      </label>
                      <label   >
                        <input
                          type="radio"
                          name="faz"
                          value={3}
                          checked={details.phaseCount === 3}
                          onChange={() => changePhaseCount(3) /* setDetails({ ...details, phaseCount: 3 } )*/}
                        />
                        3 Faz
                      </label>
                    </td>
                  </tr>

                  <tr  >
                    <td className="label-cell">Akım</td>
                    <td>{details.current.toFixed(2)}A</td>
                  </tr>
                  <tr  >
                    <td className="label-cell">Kolon</td>
                    <td>{salt.cable.title} </td>
                  </tr>
                  <tr  >
                    <td className="label-cell"  >Akım T.Kap.</td>
                    <td > {salt.cable.currentCap}A</td>
                  </tr>

                  <tr  >
                    <td className="label-cell"> Kesici </td>
                    <td>{salt.AOS.title} </td>
                  </tr>

                  <tr  >
                    <td className="label-cell">Yangın K.Ş.</td>
                    <td>{salt.YKS.title} </td>
                  </tr>
                  <tr>
                    <td colSpan={2}>
                      <button
                        /*       onClick={onApply} */
                        className="submit-button"
                        style={{ width: '100%' }}
                      >
                        Değişiklikleri Uygula
                      </button>

                    </td>
                  </tr>
                  <tr>
                    <td colSpan={2}>
                      <button
                        /*       onClick={onApply} */
                        className="submit-button"
                        style={{ width: '100%' }}
                      >
                        Eski Haline Dön
                      </button>

                    </td>
                  </tr>

                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
